"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toQueryParams = toQueryParams;
exports.fromQueryParams = fromQueryParams;
exports.fromCustomQueryParams = fromCustomQueryParams;
const serialization_1 = require("./serialization");
function toQueryParams(q) {
    return { q: JSON.stringify(q) };
}
function fromQueryParams(q) {
    if (!q.q) {
        return {};
    }
    let obj;
    try {
        obj = (0, serialization_1.jsonParse)(q.q);
    }
    catch (e) {
        // Try to decodeURIComponent first to support older API clients
        obj = (0, serialization_1.jsonParse)(decodeURIComponent(q.q));
    }
    return obj;
}
function fromCustomQueryParams(q) {
    if (!q.q) {
        return {};
    }
    let obj;
    try {
        obj = (0, serialization_1.jsonParse)(q.q);
    }
    catch (e) {
        // Try to decodeURIComponent first to support older API clients
        obj = (0, serialization_1.jsonParse)(decodeURIComponent(q.q));
    }
    return obj;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcXVlcnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFZQSxzQ0FFQztBQUVELDBDQVlDO0FBRUQsc0RBWUM7QUF2Q0QsbURBQTJDO0FBUzNDLFNBQWdCLGFBQWEsQ0FBQyxDQUFrQjtJQUM1QyxPQUFPLEVBQUUsQ0FBQyxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQTtBQUNuQyxDQUFDO0FBRUQsU0FBZ0IsZUFBZSxDQUEwQyxDQUE4QjtJQUNuRyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO1FBQ1AsT0FBTyxFQUF3QyxDQUFBO0lBQ25ELENBQUM7SUFDRCxJQUFJLEdBQUcsQ0FBQTtJQUNQLElBQUksQ0FBQztRQUNELEdBQUcsR0FBRyxJQUFBLHlCQUFTLEVBQUMsQ0FBQyxDQUFDLENBQVcsQ0FBQyxDQUFBO0lBQ2xDLENBQUM7SUFBQyxPQUFPLENBQUMsRUFBRSxDQUFDO1FBQ1QsK0RBQStEO1FBQy9ELEdBQUcsR0FBRyxJQUFBLHlCQUFTLEVBQUMsa0JBQWtCLENBQUMsQ0FBQyxDQUFDLENBQVcsQ0FBQyxDQUFDLENBQUE7SUFDdEQsQ0FBQztJQUNELE9BQU8sR0FBeUMsQ0FBQTtBQUNwRCxDQUFDO0FBRUQsU0FBZ0IscUJBQXFCLENBQVksQ0FBOEI7SUFDM0UsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQztRQUNQLE9BQU8sRUFBZSxDQUFBO0lBQzFCLENBQUM7SUFDRCxJQUFJLEdBQUcsQ0FBQTtJQUNQLElBQUksQ0FBQztRQUNELEdBQUcsR0FBRyxJQUFBLHlCQUFTLEVBQUMsQ0FBQyxDQUFDLENBQVcsQ0FBQyxDQUFBO0lBQ2xDLENBQUM7SUFBQyxPQUFPLENBQUMsRUFBRSxDQUFDO1FBQ1QsK0RBQStEO1FBQy9ELEdBQUcsR0FBRyxJQUFBLHlCQUFTLEVBQUMsa0JBQWtCLENBQUMsQ0FBQyxDQUFDLENBQVcsQ0FBQyxDQUFDLENBQUE7SUFDdEQsQ0FBQztJQUNELE9BQU8sR0FBZ0IsQ0FBQTtBQUMzQixDQUFDIn0=